import React from 'react';
import c from 'classnames';
import i18next from 'i18next';
import PropTypes from 'prop-types';

import './style.scss';

// TODO: https://uncinc.monday.com/boards/970563066/pulses/5903654737
import CustomAccordionItem from '../../CustomAccordionItem';
import CustomInlineMenu from '../../CustomInlineMenu';

const AccordionMenuItem = (props) => {
  const {
    number,
    title,
    sections,
    isCollapsed,
    onClickMenuLink,
    onChange,
  } = props;

  const classNames = c('AccordionMenu__Menu__Item');

  return (
    <CustomAccordionItem
      collapsed={isCollapsed}
      className={classNames}
      title={i18next.t('paragraph.chapter.title', { number, title })}
      iconClassName="icon-caret icon-variant-1"
      onChange={onChange}
      content={(
        <CustomInlineMenu
          scrollToTopOffset={200}
          items={sections.map((section) => ({
            elementId: section.id,
            menuItemName: (
              <a
                className="icon-before icon-caret icon-variant-1"
                href={`#${section.id}`}
                onClick={onClickMenuLink}
              >
                {i18next.t('paragraph.chapter_section.title', { number: section.number, title: section.title })}
              </a>
            ),
          }))}
        />
      )}
    />
  );
};

AccordionMenuItem.defaultProps = {
  onClickMenuLink: () => {},
};

AccordionMenuItem.propTypes = {
  number: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf(PropTypes.exact({
    id: PropTypes.string,
    number: PropTypes.string,
    title: PropTypes.string,
  })).isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClickMenuLink: PropTypes.func,
};

export default AccordionMenuItem;
